export interface IData {
  _id: string;
  stateId: string[];
  states: string[];
  priceItems: IItems[];
  createdAt: string;
  updatedAt: string;
  priceItemsForm: IItems;
}
export interface IItems {
  _id?: string;
  min: number;
  max: number;
  price: number;
  remove?: boolean;
}
export interface IState {
  _id?: string;
  name: string;
}
export enum chargesForEnum {
  USER = "USER",
  RETAILER = "RETAILER",
}

export interface ShippingState {
  formData: IData;
  list: IData[];
  stateList: IState[];
  allList: IData[];
  loading: boolean;
  buttonLoading: boolean;
  search: string;
  pageNo: number;
  pageSize: number;
  totalRow: number;
  orderBy: string;
  orderDir: string;
  toggleLoading: boolean;
  itemsLoading: boolean;
}

export type InitialState = ShippingState;
